<template>
  <div class="cancel_booking-modal">
    <div v-if="loadModal" class="modal modal-mask">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header div-responsive display-sub-title">
            <div class="modal-title">
              <h1>Cancel Booking</h1>
            </div>
            <button type="button" class="close-icon" @click="handleModal($event)" data-dismiss="modal" aria-label="Close"></button>
            <div class="">
              Please advise the reason for cancellation of this booking:
            </div>
          </div>
          <div class="modal-body div-responsive">
            <div class="box-body">
              <div class="box-row">
                <div class="box-col box-col-left">Reason</div>
                <div class="box-col box-col-right">
                  <select class="textbox" @change="onChangeReason($event)" :class="hasError && !validateBooking ? 'is-invalid' : ''">
                    <option hidden value="0">Please choose</option>
                    <option v-for="(reason, index) in cancelationReasons" :value="reason.value">{{ reason.text }}</option>
                  </select>
                  <div v-if="hasError && !validateBooking" class="text-danger">cancellation reason is required.</div>
                </div>
              </div>
              <div v-if="showDetail" class="box-row">
                <div class="box-col box-col-left">Details</div>
                <div class="box-col box-col-right">
                  <textarea v-model="reason" rows="3" maxlength="255"/>
                </div>
              </div>
            </div>

            <div class="" v-if="showMsg">
              Please Note, a cancellation fee MAY apply. To avoid, please reschedule your booking instead
            </div>
            <div class="row">
              <div class="col" style="padding-top: 20px;">
                <div class="icon-group right-float-element">
                  <v-btn
                    class="white-button"
                    @click="handleModal($event)"
                    dark>Keep Booking
                  </v-btn>
                  <v-btn v-if="showMsg"
                    dark
                    @click="tapReschedule">Reschedule
                  </v-btn>
                  <v-btn
                    @click="clickSave"
                    dark>Cancel Booking
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utilities from '@/assets/js/utilities'

export default {
  name: "CancelBookingModal",
  data() {
    return {
      loadModal: false,
      hasError: false,
      clickState: false,
      enableSave: false,
      showDetail: false,
      showMsg: false,
      reason: "",
      reasonId: "",
      cancelationReasons: utilities.getCancellationReasons(),
    }
  },

  computed: {
    user() {
      return this.$store.getters['user/getUser'];
    },
    validateBooking() {
      if (this.reason == "") {
        return false
      }
      return true
    },
  },

  methods: {
    handleModal(e) {
      this.loadModal = !this.loadModal
      if(this.loadModal) {
        $("html").addClass("modal-mask-open")
      } else {
        $("html").removeClass("modal-mask-open")
      }
    },

    onChangeReason(event) {
      this.showDetail = false
      if (event.target.value == 'Other') {
        this.showDetail = true
        this.reason = ""
      } else {
        this.reason = event.target.value
      }
      this.enableSave = true
    },

    showRescheduleMsg() {
      this.showMsg = true
    },

    async clickSave() {
      if (!this.validateBooking) {
        this.hasError = true
        return
      }

      var params = {
        BookingStatus: '6',
        ClientContactID: this.$parent.booking.ClientContactID,
        BookingTypeID: this.$parent.booking.BookingTypeID,
        CaseID: this.$parent.booking.CaseID,
        CancellationReason: this.reason,
        AvailabilityID: 0,
      }


      await this.$store.dispatch("loading/setLoadComponent", true)
      var callback = async () => {
        await this.$parent.bookingCancel()
        this.handleModal()
        if(this.reason === 'Changed to a new examinee') {
          await this.$store.dispatch("loading/setLoadComponent", false)
          await this.$router.push('/admin-search-specialist?bookingId=' + this.$parent.booking.BookingID)
        }
        await this.$store.dispatch("loading/setLoadComponent", false)
      }
      await utilities.putBooking(this.$parent.booking.BookingID, {Booking: params}, callback)
    },

    tapReschedule() {
      this.handleModal()
      this.$router.push({path:'/search-specialist', query:{id:this.$parent.booking.CaseID, bookingId: this.$parent.booking.BookingID}}).catch((err) => {})
    },

    handleState() {
      this.clickState = true
    },
  },

  async beforeMount() {
  },

  mounted() {
  },

  updated() {
  },
}
</script>
